import axios from 'axios'
import i18n from '../i18n'
import { getRuntimeEnv } from './runtime-env'

const TOKEN_KEY = 'partner_access_token'
const BASE_URL = getRuntimeEnv('VITE_API_URL')!

export const partnerApi = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
})

export function getPartnerToken(): string | null {
  return sessionStorage.getItem(TOKEN_KEY)
}

export function setPartnerToken(token: string) {
  sessionStorage.setItem(TOKEN_KEY, token)
}

export function clearPartnerToken() {
  sessionStorage.removeItem(TOKEN_KEY)
}

partnerApi.interceptors.request.use((config) => {
  const token = getPartnerToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  config.headers['Accept-Language'] = i18n.language || 'pl'
  return config
})

partnerApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearPartnerToken()
    }
    return Promise.reject(error)
  },
)
